import 'rxjs/add/operator/do';

import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { NGXLogger } from 'ngx-logger';
import { Observable } from 'rxjs';

import { AuthService } from './auth.service';

@Injectable()
export class JwtInterceptor implements HttpInterceptor {

	constructor(private logger: NGXLogger,
		public auth: AuthService,
		private router: Router) { }

	intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
		return next.handle(request).do((event: HttpEvent<any>) => {
			if (event instanceof HttpResponse) {
				// do stuff with response if you want
			}
		}, (err: any) => {
			this.logger.log('intercept error', err);
			if (err instanceof HttpErrorResponse) {
				if (err.status === 401) {
					this.auth.logout();
					this.router.navigate(['login'], {});
				}
				if (err.status === 403) {
					this.logger.log('token expired');
					// TODO 
				}
			}
		});
	}
}
